// import { makeStyles } from "@mui/styles";
import { styled, Box, Select } from "@mui/material";

export const StyledLeagueSelector = styled(Select)(() => ({
  maxWidth: "280px",
  width: "280px",
  border: "1.47px solid #C4C4C4 !important",
  borderRadius: "8px",
  margin: "3px 0px",
  padding: "4px 5px",
  fontSize: "14px !important",
  fontWeight: "700 !important",
  "::before": { display: "none" },
}));

export const StyledIconBox = styled(Box)(() => ({
  height: "42px",
  width: "42px",
  padding: 0,

  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  background: "#06623B",
  borderRadius: "10px",
  cursor: "pointer",
  marginLeft: '10px',
}));
